import React, {useEffect} from 'react';
import qs from "qs";
import commonHelper from "@/utils/commonHelper";
import commonSetting from '@/config/commonSetting';
import {useHistory} from 'react-router-dom';

export default (prop) => {
  const history = useHistory()
  let query = qs.parse(history.location.search, { ignoreQueryPrefix: true })
  let path = query.path

  console.log('location.href', location.href)
  useEffect(()=>{


  }, [])


  return <div id="authorization">
    <img src={require('@/assets/images/logo.png')} className="logo"/>
    <div className="button" onClick={async ()=>{
      await commonHelper.redirectWxAuthorizationUrl(path, commonSetting.PRODUCT_TYPE, 'snsapi_userinfo')
    }
    }>
      微信登录
    </div>

  </div>;
};
